import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';

const Section = (props) => {
   return (
      <div>
         <Row>
            <Col
               xs={props.xs}
               sm={props.sm}
               md={props.md}
               lg={props.lg}
               xl={props.xl}
            >
               <h6>
                  {props.label}
               </h6>
            </Col>
         </Row>
         <Row>
            <Col
               xs={props.xs}
               sm={props.sm}
               md={props.md}
               lg={props.lg}
               xl={props.xl}
            >
               {props.children}
            </Col>
         </Row>
      </div>
   );
};

Section.propTypes = {
   label: PropTypes.string.isRequired,
   xs: PropTypes.number,
   sm: PropTypes.number,
   md: PropTypes.number,
   lg: PropTypes.number,
   xl: PropTypes.number,
};

Section.defaultProps = {
   xs: 12,
   sm: undefined,
   md: undefined,
   lg: undefined,
   xl: undefined,
};


export default Section;
